import { render, staticRenderFns } from "./TheTracking.vue?vue&type=template&id=1a25b1ac"
import script from "./TheTracking.vue?vue&type=script&lang=ts"
export * from "./TheTracking.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports